import { render } from "./KenaikanPangkat.vue?vue&type=template&id=c6992396&ts=true"
import script from "./KenaikanPangkat.vue?vue&type=script&lang=ts"
export * from "./KenaikanPangkat.vue?vue&type=script&lang=ts"

import "./KenaikanPangkat.vue?vue&type=style&index=0&id=c6992396&lang=css"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__